import { render } from "./gameContactDetailsViewSection.vue?vue&type=template&id=cacc9e04&scoped=true"
import script from "./gameContactDetailsViewSection.vue?vue&type=script&lang=js"
export * from "./gameContactDetailsViewSection.vue?vue&type=script&lang=js"

import "./gameContactDetailsViewSection.vue?vue&type=style&index=0&id=cacc9e04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cacc9e04"]])

export default __exports__